import { createNamedContext } from "../createNamedContext";
export const EmbeddingContext = createNamedContext("embedding", null);
